<template>
  <router-view v-slot="{ Component }">
    <keep-alive max="10">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>


<script>
export default {
  name: "App",
  inject:['$isWechat','$axios'],
  data() {
    return {
      include: [],
      appid: 'wx0a3201eafb719f3c',
    }
  },
  methods: {
    wechatConfig(data) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appid, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.noncestr, // 必填，生成签名的随机串
        signature: data.sign,// 必填，签名
        jsApiList: [
          'getLocation','scanQRCode','openLocation','hideMenuItems'
        ] // 必填，需要使用的JS接口列表
      });

    },

    //微信sdk授权
    wechat() {
      let that = this;

      //获取当前访问url
      let url = window.location.href;
      url = url.split('#')[0];

      //获取微信签名
      that.$axios.post('/api/v1/wxgzh/getJsApiSign',{
        url: url,
        appid: this.appid,
      }).then(res=> {
        if (res.code == 200) {
          that.wechatConfig(res.data);
        }
      })


      wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        //隐藏按钮
        wx.hideMenuItems({
          menuList: [
            "menuItem:copyUrl",       // 隐藏复制链接
            "menuItem:openWithSafari",// 隐藏“在Safari中打开”（iOS）
            "menuItem:openWithQQBrowser" // 隐藏“在QQ浏览器中打开”（安卓）
          ]
        });
      });


    }
  },
  mounted() {

    if (this.$isWechat()) {
      //微信sdk
      this.wechat();

      document.addEventListener('WeixinJSBridgeReady', function() {
        WeixinJSBridge.call('hideOptionMenu'); // 隐藏所有非基础菜单项
      });
    }



  }
}
</script>


<style lang="scss">
 * {
   margin: 0;
 }

 #app {
   width: 100vw;
   height: 100vh;
 }

 .menu>div {
   background: none !important;
   box-shadow: none;
 }

</style>
